module.exports = __webpack_public_path__ + "img/instagram.5ec46757.svg";